export const CUSTOMER = 'customer';
export const FAMILY = 'family';
export const FAMILY_DETAILS = 'family_details';
